const infoBold = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.78 4.51H7.22v1.5h1.56zm0 2.49H7.22v4.49h1.56z" clip-rule="evenodd"/></svg>',
};

export { infoBold as default };
